import { AttentiveIntegrationPurpose } from "@redotech/cockroachdb-codegen/congodb/attentive-integration-purpose";
import { ReturnTrackingTriggerKey } from "@redotech/redo-flows-common/triggers";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const updateAttentiveIntegrationPurposes = {
  name: "updateAttentiveIntegrationPurposes" as const,
  input: z.object({
    purposes: z.array(createEnum(AttentiveIntegrationPurpose)),
    action: createEnum(["add", "remove"]),
    returnTrackingTriggers: z
      .array(createEnum(ReturnTrackingTriggerKey))
      .optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
